import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DropboxAuthComponent } from './dropbox-auth';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('dropboxauth', {
            url: '/dropbox-auth',
            params: {
                code: ''
            },
            ncyBreadcrumb: {
                label: 'Dropbox Authorization'
                // abstract: true
            },
            data: {
                pageTitle: 'Dropbox Authorization'
            },
            views: {
                'multiContent': {
                    template: '<dropbox-auth flex="100"></dropbox-auth>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const DropboxAuthModule: string = ng
    .module('archiSmall.components.dropboxAuthModule', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('dropboxAuth', DropboxAuthComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/dropbox-auth/dropbox-auth.module.ts